module.exports = __webpack_public_path__ + "static/img/describe.26472ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/home/pc/index1/describe.png
// module id = Qgg5
// module chunks = 7